
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questprojectList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"permissionFilter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"anyTarget"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"unrestrictedIfHas"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"quest.admin","block":false},{"kind":"StringValue","value":"quest.code","block":false},{"kind":"StringValue","value":"quest.deploy","block":false},{"kind":"StringValue","value":"quest.design","block":false},{"kind":"StringValue","value":"quest.export","block":false},{"kind":"StringValue","value":"quest.messaging","block":false},{"kind":"StringValue","value":"quest.permissions","block":false},{"kind":"StringValue","value":"quest.status","block":false},{"kind":"StringValue","value":"quest.tables","block":false},{"kind":"StringValue","value":"quest.view_data","block":false}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"group.label","block":false}}]}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_1_is_identifiable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_2_is_identifiable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_3_is_identifiable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_4_is_identifiable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field_5_is_identifiable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settings"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1076}};
    doc.loc.source = {"body":"{\n    groups(as: ANY) {\n        questprojectList(\n            permissionFilter: {\n                anyTarget: true\n                unrestrictedIfHas: [\n                    \"quest.admin\"\n                    \"quest.code\"\n                    \"quest.deploy\"\n                    \"quest.design\"\n                    \"quest.export\"\n                    \"quest.messaging\"\n                    \"quest.permissions\"\n                    \"quest.status\"\n                    \"quest.tables\"\n                    \"quest.view_data\"\n                ]\n            },\n            orderBy:[{field:\"group.label\"}]\n        ) {\n            fields {\n                field_1\n                field_2\n                field_3\n                field_4\n                field_5\n                field_1_is_identifiable\n                field_2_is_identifiable\n                field_3_is_identifiable\n                field_4_is_identifiable\n                field_5_is_identifiable\n            }\n            group {\n                groupId\n                label\n                settings\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
